import { defineStore } from 'pinia';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useReportDailyStore = defineStore('reportDaily', {
  state: () => ({
    buckets: {},
    loadedReportYears: [],
    unsubs: {},
    loadingYears: [],
    loadError: null,
  }),
  persist: { paths: ['buckets'] },
  getters: {
    getBucketsInRange: (state) => (minKey, maxKey) =>
      Object.entries(state.buckets)
        .filter(([key]) => key >= minKey && key <= maxKey)
        .map(([key, data]) => ({ ...data, dateKey: data.dateKey || key }))
  },
  actions: {
    ensureYearLoaded(year) {
      const y = String(year);
      if (Number(y) < 2023) return;

      if (this.unsubs[y]) {
        return;
      }
      this.loadedReportYears.push(y);
      this.loadingYears.push(y);

      const minMonth = `${y}-01`;
      const maxMonth = `${y}-12`;
      const minKey = `${y}-01-01`;
      const maxKey = `${y}-12-31`;

      const q = query(
        collection(firestore, 'reportMonthly'),
        where('monthKey', '>=', minMonth),
        where('monthKey', '<=', maxMonth)
      );

      const unsub = onSnapshot(
        q,
        (snapshot) => {
          this.loadError = null;
          const next = { ...this.buckets };
          for (const key of Object.keys(next)) {
            if (key >= minKey && key <= maxKey) delete next[key];
          }
          snapshot.docs.forEach((doc) => {
            const data = doc.data();
            const days = data?.days || {};
            for (const [dateKey, dayBucket] of Object.entries(days)) {
              next[dateKey] = { ...dayBucket, dateKey: dayBucket.dateKey || dateKey };
            }
          });
          this.buckets = next;
          this.loadingYears = this.loadingYears.filter((yr) => yr !== y);
        },
        (err) => {
          this.loadError = err?.message || 'Erro ao carregar dados do relatório.';
          this.loadingYears = this.loadingYears.filter((yr) => yr !== y);
        }
      );

      this.unsubs[year] = unsub;
    },
    clearReportDaily() {
      for (const [, unsub] of Object.entries(this.unsubs)) {
        if (typeof unsub === 'function') unsub();
      }
      this.buckets = {};
      this.loadedReportYears = [];
      this.unsubs = [];
      this.loadingYears = [];
      this.loadError = null;
    },
  },
});
